import { BASE64_FALLBACK_ERROR_IMG_TIME_CLOCK } from '@spa/scenes/TimeClockReport/hooks/constant'
import { useEffect, useState } from 'react'

/**
 * Hook that detects if the image from a given URL is a fallback error image from the old TimeClock.
 *
 *
 * @param {string} eventUrl - The URL of the image.
 * @returns {{ isImageFallbackError: boolean }} - Returns a boolean that indicate whether the image is a fallback image error.
 *
 */
export const useFallbackImageErrorCheck = (
  eventUrl?: string
): { isImageFallbackError: boolean } => {
  const [isImageFallbackError, setIsImageFallbackError] = useState(false)

  const onImageResponse = async (response: Response) => {
    const reader = new FileReader()
    const blob = await response.blob()
    reader.onloadend = () => {
      const base64ImgData = reader.result
      if (
        base64ImgData &&
        typeof base64ImgData === 'string' &&
        base64ImgData.length > BASE64_FALLBACK_ERROR_IMG_TIME_CLOCK.length
      ) {
        // We take the base64 last 30 characters of the fetch photo
        const last30base64ImgData = base64ImgData.slice(
          -BASE64_FALLBACK_ERROR_IMG_TIME_CLOCK.length
        )
        // Check if the last 30 characters of the base64 string match the last 30 characters of the fallback error image
        if (BASE64_FALLBACK_ERROR_IMG_TIME_CLOCK === last30base64ImgData) {
          setIsImageFallbackError(true)
        }
      }
    }
    reader.readAsDataURL(blob)
  }

  useEffect(
    function fetchPhotoEvent() {
      if (eventUrl) {
        fetch(eventUrl).then(onImageResponse)
      }
    },
    [eventUrl]
  )

  return { isImageFallbackError }
}
